import React from 'react';
const appDomainName = process.env.REACT_APP_DOMAIN_NAME;
export const appName = process.env.REACT_APP_NAME;
export const appPortalName = process.env.REACT_APP_PORTAL_NAME;

// /////////////////////////////////////////////////////////////////////////////////////////////////
function getDomainName() {
  let hostname = window.location.hostname;
  if (!hostname) {
    return appDomainName;
  }
  const parts = hostname.split('.'); // Split the hostname by dots

  // If the hostname has more than two parts, it means it has a sub-domain
  if (parts.length > 2) {
    // Return the last two parts joined by a dot
    return parts.slice(-2).join('.');
  }

  // If there are only two parts, return the hostname as is
  return hostname;
}

// /////////////////////////////////////////////////////////////////////////////////////////////////
export const getHostPrefix = (subDomain = 'api') => {
  if (process.env.NODE_ENV === 'production' && (!process.env.DEBUG_BUILD || process.env.DEBUG_BUILD === 'false')) {
    return `https://${subDomain}.${getDomainName()}`;
  }

  let hostPart = 'http://localhost';
  if (process.env.REACT_APP_HOST)
    hostPart = `http://${process.env.REACT_APP_HOST}`.trim();

  let hostPrefix = process.env.REACT_APP_DEV_PORT ? `${hostPart}:${process.env.REACT_APP_DEV_PORT}` : `${hostPart}:3000`;
  if (subDomain === 'api') return hostPrefix.trim();
  const portalToPort = { admin: 3000, app: 3001, reseller: 3002 };
  hostPrefix = `${hostPart}:${portalToPort[subDomain]}`;
  return hostPrefix.trim();
};
